import React from 'react'
import { Row, Col } from 'rsuite'

export default function ReportSettingView({ schema }) {
  const emptyValue = <>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</>
  console.log('000 => ', schema)
  return (
    <>
      <Row style={{ paddingLeft: '20px', paddingRight: '20px' }}>
        {schema.approveSubProject.approverName && (
          <Col>
            <h6>{schema.approveSubProject.header}</h6>
            <br />
            <p>
              {emptyValue}
              <b>
                {schema.approveSubProject.approverName.label
                  ? schema.approveSubProject.approverName.label
                  : ''}
              </b>
              <br />
              <br />
              {emptyValue}
              {emptyValue}
              <b>ชื่อ : </b>
              {schema.approveSubProject.approverName.value
                ? schema.approveSubProject.approverName.value
                : '- ไม่ระบุ -'}
              {emptyValue}
              <b>ตำแหน่ง : </b>
              {schema.approveSubProject.approveSubProjectPosition.value
                ? schema.approveSubProject.approveSubProjectPosition.value
                : '- ไม่ระบุ -'}
                <br />
                <br />
            </p>
            <p>
              {emptyValue}
              <b>
                {schema.approveSubProject.approveCoordinator.label
                  ? schema.approveSubProject.approveCoordinator.label
                  : ''}
              </b>
              <br />
              <br />
              {emptyValue}
              {emptyValue}
              <b>ชื่อ : </b>
              {schema.approveSubProject.approveCoordinator.value
                ? schema.approveSubProject.approveCoordinator.value
                : '- ไม่ระบุ -'}
              {emptyValue}
              <b>ตำแหน่ง : </b>
              {schema.approveSubProject.approveCoordinatorPosition.value
                ? schema.approveSubProject.approveCoordinatorPosition.value
                : '- ไม่ระบุ -'}
                <br />
                <br />
            </p>
          </Col>
        )}

        {schema.printContract.projectManagerName && (
          <Col style={{ marginTop: '50px' }}>
            <h6>{schema.printContract.header}</h6>
            <br />
            <p>
              {emptyValue}
              <b>
                {schema.printContract.projectManagerName.label
                  ? schema.printContract.projectManagerName.label
                  : ''}
              </b>
              <br />
              <br />
              {emptyValue}
              {emptyValue}
              <b>ชื่อ : </b>
              {schema.printContract.projectManagerName.value
                ? schema.printContract.projectManagerName.value
                : '- ไม่ระบุ -'}
              {emptyValue}
              <b>ตำแหน่ง : </b>
              {schema.printContract.projectManagerPosition.value
                ? schema.printContract.projectManagerPosition.value
                : '- ไม่ระบุ -'}
                <br />
                <br />
            </p>
            <p>
              {emptyValue}
              <b>
                {schema.printContract.projectLeaderName.label
                  ? schema.printContract.projectLeaderName.label
                  : ''}
              </b>
              <br />
              <br />
              {emptyValue}
              {emptyValue}
              <b>ชื่อ : </b>
              {schema.printContract.projectLeaderName.value
                ? schema.printContract.projectLeaderName.value
                : '- ไม่ระบุ -'}
              {emptyValue}
              <b>ตำแหน่ง : </b>
              {schema.printContract.projectLeaderPosition.value
                ? schema.printContract.projectLeaderPosition.value
                : '- ไม่ระบุ -'}
                <br />
                <br />
            </p>
            <p>
              {emptyValue}
              <b>
                {schema.printContract.firstWitnessName.label
                  ? schema.printContract.firstWitnessName.label
                  : ''}
              </b>
              <br />
              <br />
              {emptyValue}
              {emptyValue}
              <b>ชื่อ : </b>
              {schema.printContract.firstWitnessName.value
                ? schema.printContract.firstWitnessName.value
                : '- ไม่ระบุ -'}
              {emptyValue}
              <b>ตำแหน่ง : </b>
              {schema.printContract.firstWitnessPosition.value
                ? schema.printContract.firstWitnessPosition.value
                : '- ไม่ระบุ -'}
                <br />
                <br />
            </p>
            <p>
              {emptyValue}
              <b>
                {schema.printContract.secondWitnessName.label
                  ? schema.printContract.secondWitnessName.label
                  : ''}
              </b>
              <br />
              <br />
              {emptyValue}
              {emptyValue}
              <b>ชื่อ : </b>
              {schema.printContract.secondWitnessName.value
                ? schema.printContract.secondWitnessName.value
                : '- ไม่ระบุ -'}
              {emptyValue}
              <b>ตำแหน่ง : </b>
              {schema.printContract.secondWitnessPosition.value
                ? schema.printContract.secondWitnessPosition.value
                : '- ไม่ระบุ -'}
                <br />
                <br />
            </p>
          </Col>
        )}

        {schema.projectWithdrawalRequestForm.projectManagerApproveName && (
          <Col style={{ marginTop: '50px' }}>
            <h6>{schema.projectWithdrawalRequestForm.header}</h6>
            <br />
            <p>
              {emptyValue}
              <b>
                {schema.projectWithdrawalRequestForm.projectManagerApproveName.label
                  ? schema.projectWithdrawalRequestForm.projectManagerApproveName.label
                  : ''}
              </b>
              <br />
              <br />
              {emptyValue}
              {emptyValue}
              <b>ชื่อ : </b>
              {schema.projectWithdrawalRequestForm.projectManagerApproveName.value
                ? schema.projectWithdrawalRequestForm.projectManagerApproveName.value
                : '- ไม่ระบุ -'}
              {emptyValue}
              <b>ตำแหน่ง : </b>
              {schema.projectWithdrawalRequestForm.projectManagerApprovePosition.value
                ? schema.projectWithdrawalRequestForm.projectManagerApprovePosition.value
                : '- ไม่ระบุ -'}
                <br />
                <br />
            </p>
          </Col>
        )}

        {schema.reportSummary && (
          <Col style={{ marginTop: '50px' }}>
            <h6>{schema.reportSummary.header}</h6>
            <br />
            <p>
              {emptyValue}
              <b>
                {schema.reportSummary.reportSummaryName.label
                  ? schema.reportSummary.reportSummaryName.label
                  : ''}
              </b>
              <br />
              <br />
              {emptyValue}
              {emptyValue}
              <b>ชื่อ : </b>
              {schema.reportSummary.reportSummaryName.value
                ? schema.reportSummary.reportSummaryName.value
                : '- ไม่ระบุ -'}
              {emptyValue}
              <b>ตำแหน่ง : </b>
              {schema.reportSummary.reportSummaryPosition.value
                ? schema.reportSummary.reportSummaryPosition.value
                : '- ไม่ระบุ -'}
                <br />
                <br />
            </p>
          </Col>
        )}
      </Row>
    </>
  )
}
